import axios from 'axios';
import { useQuery } from 'react-query';

// LJ - restrictAccessFunc is used on the create screen
// because we don't want the user to be able to create cards
// without the families list
const useGetFamilies = () => {
  const { data, isLoading } = useQuery('families', async () => {
    return (await axios.get(`/idcards/families`)).data;
  });

  return {
    families: data,
    isLoading,
  };
};

export default useGetFamilies;
